import { Component } from '@angular/core';

@Component({
  selector: 'contract-layout',
  template: `<ng-content></ng-content>`
})
export class LayoutComponent {}
